// lib/supabase/client.js
import { createClient } from '@supabase/supabase-js';

// Use globalThis for browser/server compatibility
// This ensures singleton pattern works in all environments
if (typeof globalThis.supabaseClient === 'undefined') {
  globalThis.supabaseClient = null;
}
if (typeof globalThis.supabaseServiceClient === 'undefined') {
  globalThis.supabaseServiceClient = null;
}

// Create browser client for client-side operations
export function createBrowserClient() {
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
  
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase URL or Anon Key');
  }
  
  // Removed logging to prevent flooding
  
  return createClient(supabaseUrl, supabaseAnonKey);
}

// Get regular Supabase client (respects RLS)
export function getSupabaseClient() {
  if (!globalThis.supabaseClient) {
    globalThis.supabaseClient = createBrowserClient();
  }
  return globalThis.supabaseClient;
}

// Get Supabase service client (bypasses RLS)
export function getSupabaseServiceClient() {
  if (!globalThis.supabaseServiceClient) {
    const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
    const supabaseServiceKey = process.env.SUPABASE_SERVICE_KEY;
    
    if (!supabaseUrl || !supabaseServiceKey) {
      throw new Error('Missing Supabase URL or Service Key');
    }
    
    // Removed logging to prevent flooding
    
    globalThis.supabaseServiceClient = createClient(supabaseUrl, supabaseServiceKey, {
      auth: {
        autoRefreshToken: false,
        persistSession: false
      }
    });
  }
  return globalThis.supabaseServiceClient;
}

// Alias for backward compatibility
export const createAdminClient = getSupabaseServiceClient;
